/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Definition_SourceInputs */

const en_landing_definition_source = /** @type {(inputs: Landing_Definition_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data is processed in the EU under GDPR Art. 6(1)(b). For current provider, region, and data-flow details, see /privacy.`)
};

const de_landing_definition_source = /** @type {(inputs: Landing_Definition_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daten werden in der EU gemaess DSGVO Art. 6(1)(b) verarbeitet. Aktuelle Anbieter-, Regions- und Datenflussinformationen: /privacy.`)
};

const fr_landing_definition_source = /** @type {(inputs: Landing_Definition_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les donnees sont traitees dans l'UE conformement au RGPD Art. 6(1)(b). Pour les details actuels sur les fournisseurs, regions et flux de donnees, voir /privacy.`)
};

const es_landing_definition_source = /** @type {(inputs: Landing_Definition_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los datos se procesan en la UE bajo el RGPD Art. 6(1)(b). Para detalles actuales sobre proveedor, region y flujo de datos, ver /privacy.`)
};

const it_landing_definition_source = /** @type {(inputs: Landing_Definition_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I dati sono elaborati nell'UE ai sensi del GDPR Art. 6(1)(b). Per i dettagli attuali su fornitori, regioni e flussi di dati, vedere /privacy.`)
};

const nl_landing_definition_source = /** @type {(inputs: Landing_Definition_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gegevens worden verwerkt in de EU onder AVG Art. 6(1)(b). Voor actuele details over aanbieder, regio en gegevensstroom, zie /privacy.`)
};

const pl_landing_definition_source = /** @type {(inputs: Landing_Definition_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dane sa przetwarzane w UE zgodnie z RODO Art. 6(1)(b). Aktualne informacje o dostawcy, regionie i przeplywach danych: /privacy.`)
};

const fi_landing_definition_source = /** @type {(inputs: Landing_Definition_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tietoja kasitellaan EU:ssa GDPR Art. 6(1)(b) nojalla. Ajantasaiset tiedot palveluntarjoajista, alueista ja tietovirroista: /privacy.`)
};

const da_landing_definition_source = /** @type {(inputs: Landing_Definition_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data behandles i EU i henhold til GDPR Art. 6(1)(b). For aktuelle oplysninger om udbyder, region og dataflow, se /privacy.`)
};

const sv_landing_definition_source = /** @type {(inputs: Landing_Definition_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data behandlas i EU enligt GDPR Art. 6(1)(b). For aktuell information om leverantor, region och datafloden, se /privacy.`)
};

/**
* | output |
* | --- |
* | "Data is processed in the EU under GDPR Art. 6(1)(b). For current provider, region, and data-flow details, see /privacy." |
*
* @param {Landing_Definition_SourceInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_definition_source = /** @type {((inputs?: Landing_Definition_SourceInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Definition_SourceInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_definition_source(inputs)
	if (locale === "fr") return fr_landing_definition_source(inputs)
	if (locale === "es") return es_landing_definition_source(inputs)
	if (locale === "it") return it_landing_definition_source(inputs)
	if (locale === "nl") return nl_landing_definition_source(inputs)
	if (locale === "pl") return pl_landing_definition_source(inputs)
	if (locale === "fi") return fi_landing_definition_source(inputs)
	if (locale === "da") return da_landing_definition_source(inputs)
	if (locale === "sv") return sv_landing_definition_source(inputs)
	return en_landing_definition_source(inputs)
});